import { css } from '@emotion/react'
import { useMemo, useRef } from 'react'

import type { IApplication } from '@/apis/apps/interfaces'
import { Carousel } from '@/components/Carousel/Carousel'
import { CarouselItem } from '@/components/Carousel/CarouselItem'
import type { Slide } from '@/components/Carousel/interfaces'
import useHydrationContext from '@/hooks/useHydrationContext'

import { PRODUCT_PAGE_TABS } from '@/constants'
import Section from '../Section'
import DevAppCard from './DevProductCard'

const CARD_WIDTH = 280

const cardSlideCss = css`
  flex: 1 0 ${CARD_WIDTH}px;
  max-width: ${CARD_WIDTH}px;
`

const getAppCardSlides = (apps: IApplication[]): Slide[] =>
  apps.map((app) => ({
    type: 'appCard',
    component: <DevAppCard app={app} />,
    id: app.id,
  }))

interface Props {
  products: IApplication[]
  heading: string
}

const MoreByDev = ({ products = [], heading }: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const hydrated = useHydrationContext()
  const slides = useMemo(() => getAppCardSlides(products), [products])

  return (
    <Section
      id={PRODUCT_PAGE_TABS.MORE_BY_DEVELOPER}
      title={heading}
      ref={wrapperRef}
      hideDivider
    >
      {hydrated && (
        <Carousel
          items={slides}
          renderItem={({ item, isSnapPoint }) => (
            <CarouselItem
              key={item.id}
              isSnapPoint={isSnapPoint}
              css={cardSlideCss}
            >
              <div>{item.component}</div>
            </CarouselItem>
          )}
        />
      )}
    </Section>
  )
}

export default MoreByDev
